import logoSvg from '../../Navbar/assets/logo.svg';

interface ReportHeaderProps {
  projectName: string;
  projectDescription: string;
  timestamp: string;
}

export function ReportHeader({ projectName, projectDescription, timestamp }: ReportHeaderProps) {
  const formattedDate = new Date(timestamp).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  return (
    <header className="report-header mb-4">
      <div className="flex justify-between items-start">
        <div>
          <h1 className="text-[2rem] font-bold text-[#0C2856] leading-tight">
            Relatório Simplificado
          </h1>
          <span className="text-[0.85rem] text-[#555]">{formattedDate}</span>
        </div>
        <img src={logoSvg} alt="Plataforma Energética de Pernambuco" className="h-12 w-auto" />
      </div>

      {(projectName || projectDescription) && (
        <div className="mt-5">
          {projectName && (
            <h2 className="text-[1.1rem] font-bold text-[#0C2856] mb-1">{projectName}</h2>
          )}
          {projectDescription && (
            <p className="text-[0.88rem] text-[#444] leading-relaxed">{projectDescription}</p>
          )}
        </div>
      )}

      <hr className="border-0 border-t border-[#ddd] mt-4 mb-2" />
    </header>
  );
}
